import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LOGIN_STEPS } from '../../constants/login';
import { ONBOARDING } from '../../constants/routes';
import AuthUserTemplate from '../../components/templates/auth-user';
import LoginError from '../../domain/workspaces/login/login-error';

import useAuth from '../../context/AuthContext';
import useLoader from '../../context/LoaderContext';

const AuthError = () => {
  // init
  const { setIsLoading } = useLoader();
  const { authUser } = useAuth();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setIsLoading(false);
  }, [authUser]);

  return (
    <AuthUserTemplate loginStep={LOGIN_STEPS.LOGIN_ERROR}>
      <LoginError linkText="Go to Onboarding Page" onLinkClick={() => navigate(`/${ONBOARDING}`)} />
    </AuthUserTemplate>
  );
};

export default AuthError;
